import * as R from 'ramda';
import { useTranslation } from 'react-i18next';
// ui
import { Box, Flex, StickedBox } from '../../../ui';
// component virtualized table
import { HeaderCellWrapper } from '../ui';
import { stickedRightStyles } from '../settings';
////////////////////////////////////////////////

const ResultsHeader = props => {
  const {
    style,
    orderBy,
    itemSize,
    // handleSort,
    columnSettings,
  } = props;

  const { t } = useTranslation();

  return (
    <StickedBox zIndex={1} bg='white' {...style}>
      <Flex
        bg='white'
        minWidth='100%'
        height={itemSize}
        fontWeight='bold'
        width='fit-content'
        borderBottom='1px solid black'
      >
        {
          columnSettings.map(({
            name,
            label,
            width,
            // sortable,
            titleHidden,
            stickedRight,
          }) => {
            const additionalStyles = stickedRight ? stickedRightStyles : {};

            return (
              <HeaderCellWrapper
                {...additionalStyles}
                p='8px'
                width={width}
                isActive={R.equals(name, orderBy)}
                key={`search-results-header-row-cell-${name}`}
              >
                <Box title={t(label)}>
                  {R.not(titleHidden) && t(label)}
                </Box>
              </HeaderCellWrapper>
            );
          })
        }
      </Flex>
    </StickedBox>
  );
};

export default ResultsHeader;
